export const generateFieldId = (badge: string, fieldType? : string): any => {
    let id = '';

    if (!! badge) {
        id = replaceAll(badge, " ", "");
        id = replaceAll(id, "/", "");
        id = replaceAll(id, ",", "");
        id = replaceAll(id ,":", "");
        id = id.replace(id[0], id[0].toLowerCase());
    }

    if(!!fieldType)
    {
        id = id + fieldType + 'Id';
    }

    return id;
}


function replaceAll(string, search, replace) {
    return string.split(search).join(replace);
}

// simple function to hash a string
export const createUniqueID = (str: string): number => {
    let hash = 0;

    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0; // Convert to 32-bit integer
    }
    return Math.abs(hash);
}
